import AttendanceAdapter from './base';

export default class ResponseActivity extends AttendanceAdapter {
  modelNamePlural = 'responseActivities';
}
